<template>
    <div class="content">
        <h2>DISABILITY</h2>
        <h4>An Illness or Injury and any symptoms, sequelae, or complication thereof requiring treatment. All injuries arising from the same event or series of continuous events are considered as one Disability.</h4>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.content {
  margin: auto;
  padding: 10px;
}
.content h2 {
  font-size: 16px;
  text-align: justify;
  color: #1b5e20;
}
.content h4 {
  font-weight: normal;
  font-size: 13px;
  text-align: justify;
  padding-left: 10px;
}
.content ul li {
  font-size: 13px;
  color: black;
  margin-top: 10px;
  list-style: none;
  text-align: justify;
}
@media (max-width: 599px) {
  .content {
    width: 90%;
    margin-top: 10px;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .content {
   
    width: 80%;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  .content {
    width: 100%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .content {
    width: 100%;
  }
}
</style>
